import { render, staticRenderFns } from "./CustomerBrandLogo.vue?vue&type=template&id=ab4ddeb2&scoped=true&"
import script from "./CustomerBrandLogo.vue?vue&type=script&lang=js&"
export * from "./CustomerBrandLogo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBrandLogo.vue?vue&type=style&index=0&id=ab4ddeb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4ddeb2",
  null
  
)

export default component.exports